/* eslint-disable max-lines-per-function */

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../translations';

import { MedicalServiceUpdateForm, MedicalServiceUpdateFormLoader } from './MedicalServiceUpdateForm';
import { MedicalServiceUpdateAction } from './MedicalServiceUpdateModal.actions';

type MedicalServiceUpdateModalProps = {
   readonly onSuccess: VoidFunction;
   readonly medicalServiceId: number;
   readonly closeModal: VoidFunction;
};

export const MedicalServiceUpdateModal = (props: MedicalServiceUpdateModalProps): JSX.Element => {
   return (
      <Modal
         testId={'medicalServiceUpdate'}
         title={medicalServiceTranslationKeys.update.modal.title}
         width={ModalWidth.HUGE}
      >
         <MedicalServiceUpdateFormLoader id={props.medicalServiceId}>
            {({ practitioners, taxRates, medicalService, fiscalPrintEnabled }) => (
               <MedicalServiceUpdateForm
                  medicalService={medicalService}
                  practitioners={practitioners}
                  taxRates={taxRates}
                  fiscalPrintEnabled={fiscalPrintEnabled}
               >
                  {({ handleSubmit, formState, setNotUniqueMedicalServiceNameError }) => (
                     <>
                        <MedicalServiceUpdateAction
                           onSuccess={props.onSuccess}
                           onMedicalServiceAlreadyExistsFault={setNotUniqueMedicalServiceNameError}
                        >
                           {({ updateMedicalService }) => (
                              <ModalConfirmButton
                                 label={medicalServiceTranslationKeys.update.modal.confirm}
                                 onClick={handleSubmit(updateMedicalService)}
                                 variant={ButtonVariant.PRIMARY}
                              />
                           )}
                        </MedicalServiceUpdateAction>
                        <ModalCancelButton
                           label={commonTranslationKeys.cancel}
                           onClick={props.closeModal}
                           shouldConfirmExit={formState.isDirty}
                        />
                        <ModalCloseButton onClick={props.closeModal} shouldConfirmExit={formState.isDirty} />
                     </>
                  )}
               </MedicalServiceUpdateForm>
            )}
         </MedicalServiceUpdateFormLoader>
      </Modal>
   );
};
